import {
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
} from '../../../../atoms';

export const AdvancedFiltersFieldOption = {
  Item: SelectItem,
  Separator: SelectSeparator,
  Group: SelectGroup,
  GroupLabel: SelectLabel,
};
